import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Composition from "./composition/convert-to-input";
import { CreateContact } from "./mutation";

import type { ContactCreateInputZodSchemaType } from "../../schema";

export const useContactCreateMutation = () => {
	const { mutationFunc } = useCustomMutation(CreateContact);

	const createContact = useCallback(
		async (contact: ContactCreateInputZodSchemaType) => {
			const input = Composition.convertToToInput({ contact });

			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return {
		createContact,
	};
};
